export const dtm = ['INTEL_DTM_STNDRD', 'INTEL_DTM_ADV']
